// import { Edit, Save } from "lucide-react";
// import { useState, useEffect } from "react";
// import { editAboutMeProfile, EditAboutMeType } from "@/api/profile";
// import { useMutation, useQueryClient } from "@tanstack/react-query";
// import { cn } from "@/lib/utils";
import { useProfile } from "@/hooks/server-state/use-profile";

import AnimatedBackground from "@/components/ui/animated-background";

import ProfileImage from "./profile-image";

const ProfileHeader = () => {
  const { data: profileData } = useProfile();

  // Debug logging
  // useEffect(() => {
  //   console.log("ProfileHeader - Profile data:", profileData);
  // }, [profileData]);

  // const [editingField, setEditingField] = useState<string | null>(null);
  // const [editData, setEditData] = useState<EditAboutMeType>({
  //   id: profileData?.id,
  //   universityEmail: profileData?.universityEmail,
  //   personalEmail: profileData?.personalEmail,
  //   phone: profileData?.phone,
  //   mobileNumber: profileData?.mobileNumber,
  //   biographyEn: profileData?.biographyEn,
  //   biographyFa: profileData?.biographyFa,
  //   lastName: profileData?.lastNameEn,
  //   firstName: profileData?.firstNameEn,
  //   orcid: profileData?.orcidId,
  //   googleScholar: profileData?.googleScholarID,
  //   scopus: profileData?.scopusID,
  //   isi: profileData?.webOfScienceID,

  //   // مقادیر پیش‌فرض برای آرایه‌های اجباری
  //   nickName: [],
  //   moreEmails: [],
  //   affilations: []
  // });

  // const queryClient = useQueryClient();

  // const mutateData = useMutation({
  //   mutationFn: (data: EditAboutMeType) => editAboutMeProfile(data),
  //   onSuccess: () => queryClient.invalidateQueries({ queryKey: ["profile"] })
  // });

  // const handleSubmit = async () => {
  //   mutateData.mutate(editData);

  //   setEditingField(null);
  // };
  return (
    <div className="relative mb-3 h-40 ps-24">
      <div className="size-full bg-gradient-to-b from-[#162b41] to-[#033d61]">
        <AnimatedBackground />
        <div className="relative z-10 flex size-full items-center">
          <ProfileImage />
          <div className="mx-5 flex flex-1 justify-between text-white">
            <div className="space-y-1">
              <p className="mb-2 font-semibold lg:mb-5">
                {profileData?.degree ? `${profileData.degree}` : ""}{" "}
                {`${profileData?.firstNameFa} ${profileData?.lastNameFa}`}
              </p>
              <p className="text-sm">{profileData?.positionFA}</p>
              {profileData?.organization?.facultyTitleFa && (
                <p className="text-sm">
                  دانشکده: {profileData.organization.facultyTitleFa}
                </p>
              )}
              {profileData?.organization?.departmentTitleFa && (
                <p className="text-sm">
                  گروه آموزشی: {profileData.organization.departmentTitleFa}
                </p>
              )}
            </div>
            <div className="hidden space-y-1 lg:block" dir="ltr">
              <div className="mb-2 flex items-center gap-x-2 lg:mb-5">
                <p className="">
                  {profileData?.firstNameEn} {profileData?.lastNameEn}
                </p>
                {/* {editingField !== "name" ? (
                  <p className="">
                    {profileData?.firstNameEn} {profileData?.lastNameEn}
                  </p>
                ) : (
                  <>
                    <input
                      defaultValue={profileData?.firstNameEn || ""}
                      onChange={(e) => {
                        setEditData((prev) => ({
                          ...prev,
                          firstName: e.target.value
                        }));
                      }}
                      className="w-28 rounded-md border border-slate-300 p-1 font-semibold text-black disabled:border-transparent disabled:bg-transparent disabled:text-white"
                      dir="ltr"
                      disabled={editingField !== "name"}
                    />
                    <input
                      defaultValue={profileData?.lastNameEn || ""}
                      onChange={(e) => {
                        setEditData((prev) => ({
                          ...prev,
                          lastName: e.target.value
                        }));
                      }}
                      className="w-28 rounded-md border border-slate-300 p-1 font-semibold text-black disabled:border-transparent disabled:bg-transparent disabled:text-white"
                      dir="ltr"
                      // disabled={editingField !== "name"}
                    />
                  </>
                )} */}
                <div
                  // className={cn(
                  //   "flex size-6 items-center justify-center",
                  //   editingField === "name" && "rounded bg-primary text-white"
                  // )}
                  className="flex size-6 items-center justify-center"
                >
                  {/* {editingField === "name" ? (
                    <button onClick={handleSubmit}>
                      <Save size={20} />
                    </button>
                  ) : (
                    <button onClick={() => setEditingField("name")}>
                      <Edit size={16} className="text-primary" />
                    </button>
                  )} */}
                </div>
              </div>
              <p className="text-sm">{profileData?.position}</p>
              {profileData?.organization?.facultyTitleEn && (
                <p className="text-sm">
                  Faculty of {profileData.organization.facultyTitleEn}
                </p>
              )}
              {profileData?.organization?.departmentTitleEn && (
                <p className="text-sm">
                  Department of {profileData.organization.departmentTitleEn}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProfileHeader;
